var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVscode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 510,
    height: 508,
    viewBox: "0 0 510 508",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2702_605",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 511,
    height: 508
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M361.655 505.21C369.688 508.34 378.848 508.139 386.956 504.238L491.958 453.713C502.991 448.404 510.008 437.236 510.008 424.986V82.394C510.008 70.1435 502.991 58.9769 491.958 53.6676L386.956 3.14104C376.316 -1.97884 363.863 -0.72479 354.525 6.06436C353.19 7.03421 351.919 8.11706 350.728 9.3104L149.713 192.699L62.1556 126.236C54.0048 120.049 42.6042 120.556 35.0341 127.442L6.95156 152.987C-2.30805 161.41 -2.31867 175.977 6.92863 184.414L82.8615 253.689L6.92863 322.964C-2.31867 331.401 -2.30805 345.968 6.95156 354.391L35.0341 379.936C42.6042 386.823 54.0048 387.329 62.1556 381.143L149.713 314.678L350.728 498.068C353.908 501.25 357.641 503.646 361.655 505.21ZM382.584 137.912L230.059 253.689L382.584 369.466V137.912Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2702_605)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M492.27 53.7463L387.186 3.15015C375.024 -2.70634 360.486 -0.235945 350.94 9.30996L6.93283 322.964C-2.32008 331.401 -2.30944 345.968 6.95578 354.391L35.0554 379.936C42.6302 386.823 54.0378 387.329 62.1934 381.143L476.457 66.8723C490.355 56.3291 510.317 66.2415 510.317 83.6862V82.4662C510.317 70.221 503.302 59.0584 492.27 53.7463Z",
    fill: "#0065A9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.27 453.632L387.186 504.228C375.024 510.083 360.486 507.613 350.94 498.068L6.93283 184.414C-2.32008 175.977 -2.30944 161.41 6.95578 152.987L35.0554 127.441C42.6302 120.555 54.0378 120.048 62.1934 126.236L476.457 440.505C490.355 451.048 510.317 441.136 510.317 423.691V424.912C510.317 437.156 503.302 448.318 492.27 453.632Z",
    fill: "#007ACC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.857 504.269C374.69 510.12 360.153 507.647 350.606 498.101C362.368 509.863 382.482 501.531 382.482 484.896V22.5456C382.482 5.91052 362.368 -2.42043 350.606 9.34239C360.153 -0.204404 374.69 -2.67829 386.857 3.17303L491.922 53.6997C502.963 59.009 509.984 70.1755 509.984 82.4261V425.018C509.984 437.268 502.963 448.435 491.922 453.744L386.857 504.269Z",
    fill: "#1F9CF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.656 505.21C369.688 508.338 378.849 508.139 386.955 504.238L491.957 453.712C502.992 448.402 510.008 437.236 510.008 424.986V82.3938C510.008 70.1433 502.992 58.9767 491.959 53.6674L386.955 3.14088C376.317 -1.97901 363.863 -0.724961 354.524 6.06419C353.191 7.03404 351.92 8.11689 350.726 9.31023L149.713 192.699L62.1555 126.236C54.0049 120.049 42.6041 120.556 35.034 127.442L6.95156 152.987C-2.30805 161.41 -2.31867 175.977 6.92863 184.414L82.8616 253.689L6.92863 322.964C-2.31867 331.401 -2.30805 345.968 6.95156 354.392L35.034 379.936C42.6041 386.823 54.0049 387.329 62.1555 381.143L149.713 314.679L350.726 498.068C353.906 501.25 357.641 503.646 361.656 505.21ZM382.584 137.911L230.06 253.689L382.584 369.467V137.911Z",
    fill: "url(#paint0_linear_2702_605)",
    fillOpacity: 0.25
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2702_605",
    x1: 255.004,
    y1: -0.000169834,
    x2: 255.004,
    y2: 507.378,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVscode);
export default __webpack_public_path__ + "static/media/vscode.f5afdf1c4c0b365325db1e067c48782d.svg";
export { ForwardRef as ReactComponent };